import React from 'react';
import './commandPanelImage.scss';
import NavigatorCommandPanelIcons, {
  NavigatorDrawingsProps,
} from './Navigator/NavigatorDrawingIcons';
import Scores from 'components/plateviewer/plate/Scores';
import { Layer, Stage } from 'react-konva';
interface CommandPanelImagProps {
  image: any;
  inspectionName: any;
  imageName: any;
  inspectionDateTime: any;
  active: any;
  onClick: any;
  children?: any;
  iconImages: NavigatorDrawingsProps;
  currentWellScores: any;
}
function CommandPanelImage({
  image,
  inspectionName,
  imageName,
  inspectionDateTime,
  active,
  onClick,
  children,
  iconImages,
  currentWellScores,
}: CommandPanelImagProps) {
  return (
    <div
      id="commandpanelimage-wrapper"
      className={`flex flex-col items-center w-[13.4vw] h-[45%] box-border py-[0.6em] mt-[1%] ml-[2%] ${
        active
          ? 'bg-[#85baff] text-white border-none'
          : 'border border-[#5c5c5c] text-black'
      }`}
      onClick={onClick}
    >
      <div
        id="commandpanelimage-content-header"
        className="flex-none flex flex-col items-center justify-center mb-1"
      >
        <div className="font-bold text-[0.75rem] leading-[0.875rem] text-center font-[Arial]">
          {imageName}
        </div>
        <div className="text-[0.813rem] leading-[0.938rem] text-center">
          {inspectionDateTime}
        </div>
        <div className="text-[0.813rem] leading-[0.938rem] text-center">
          {inspectionName}
        </div>
      </div>
      {currentWellScores && currentWellScores.length > 0 && (
        <div className="flex-none">
          <Stage
            id="commandpanelimage-currentwellscores-stage"
            width={(currentWellScores.length + 1) * 24}
            height={24}
          >
            <Layer id="commandpanelimage-currentwellscores-layer">
              <Scores
                scoresOfWellDrops={currentWellScores}
                width={24}
                height={24}
                x={0}
                y={0}
                scale={1}
              />
            </Layer>
          </Stage>
        </div>
      )}
      <div
        id="commandpanelimage-img-container"
        className="flex-1 flex flex-col items-center justify-center w-[85%] min-h-0"
      >
        {children}
        {image ? (
          <img
            id="commandpanelimage-img"
            src={image}
            className="w-[85%] rounded-[5px] max-h-full object-contain"
            alt="No Image"
          />
        ) : (
          <div
            id="commandpanelimage-noimage"
            className="flex items-center justify-center w-[85%] rounded-[5px]"
          >
            No Image
          </div>
        )}
      </div>
      {image && iconImages && (
        <div
          id="commandpanelimage-icons-wrapper"
          className="flex-none flex items-center justify-center pt-[0.5vh]"
        >
          <NavigatorCommandPanelIcons {...iconImages} />
        </div>
      )}
    </div>
  );
}
export default CommandPanelImage;
